<div class="profile-picture-panel">
  <img
    [src]="profilePicture || 'assets/img/person.png'"
    class="profile-picture"
  />
</div>
